<div id="section-banner-container">
    <!-- TODO: coger diferentes imagenes para móvil -->
     <picture>
        <source [srcset]="bannerContent().bannerImgMobile" media="(max-width: 1024px)">
        <img [src]="bannerContent().bannerImg">
     </picture>
    <div id="section-banner-text-container">
        <h2>{{bannerContent().bannerTitle}}</h2>
        <p>{{bannerContent().bannerText}}</p>
    </div>
</div>